import { Component, OnInit,Input } from '@angular/core';
import {OktaAuthService} from "@okta/okta-angular";
import {NavigationEnd, Router} from "@angular/router";
import { DeviceDetectorService } from 'ngx-device-detector';
// @ts-ignore
import routeRoles from "../../../assets/routeRoles.json";
import {UtilService} from "../../services/util.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() showDropDownMenu: Boolean = false;
  routesRoles: any = routeRoles;
  currentPath
  horizontalMenu = true;
  menuList;
  pricingTypeMenuList = [
    {
      id: 'admin',
      label: 'Admin',
      link: '/admin',
      children: [
        {
          label: 'Impersonation',
          link: '/admin'
        },
        {
          label: 'Contract Templates',
          link: '/contract-templates'
        },
        {
          label: 'Disable Contracts',
          link: '/disable-contract-download'
        }
      ]
    },
      {
        id: 'dashboard',
        label: 'Dashboard',
        link: '/dashboard'
      },
      {
        id: 'dashboard',
        label: 'Quick Quotes',
        link: '/quick-quotes',
        children: [
          {
            label: 'Create New',
            link: '/quick-quotes',
          },
          {
            label: 'Request History',
            link: '/price-history'
          }
        ]
      }
    ];
  constructor(private oktaAuthService: OktaAuthService,private router: Router, private deviceService: DeviceDetectorService, public utilService: UtilService) {

    this.oktaAuthService.getUser().then(data => {
      this.menuList = this.pricingTypeMenuList;
    })

    router.events.subscribe((val) => {

      if (val instanceof NavigationEnd) {
        this.currentPath = val.urlAfterRedirects;
      }
    })


  }

  ngOnInit(): void {
    // this.checkMenu();
    this.currentPath = this.router.url
  }

  checkMenu(){
    if(this.deviceService.orientation !='portrait'){
     this.horizontalMenu = true;
    } else if(this.deviceService.isMobile() || this.deviceService.isTablet()){
     this.horizontalMenu = false;
    }
  }
}
